module.exports = __webpack_public_path__ + "1bd73cd1c1ff4abd6b555b247290eb82.svg";